// biome-ignore-all lint/plugin/no-unlabeled-form-inputs: legacy unlabeled inputs, burn-down tracked in HTUI-392
import { HTImage } from "src/components/image";
import { FC } from "react";

import { Box, Radio, RadioGroup, Select, Text } from "@hightouch/htui";

import dbtLogo from "./images/dbt-logo.svg";
import googleSheetsLogo from "./images/google-sheets-logo.svg";
import lookerLogo from "./images/looker-logo.svg";
import schemaIcon from "./images/schema-icon.svg";
import sigmaLogo from "./images/sigma-logo.svg";

const noop = () => {};

export const BrowserImage: FC = () => (
  <Box
    aria-hidden
    bg="white"
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    className="preview-image"
    height="100px"
    overflow="hidden"
    p={4}
    pointerEvents="none"
  >
    <Box transform="scale(0.8)" transformOrigin="top left">
      <RadioGroup value="one" onChange={noop}>
        <Radio label="Source 1" value="one" />
        <Radio label="Source 2" value="two" />
      </RadioGroup>

      <Select
        mt={4}
        optionAccessories={() => ({
          leftAccessory: {
            type: "image",
            url: googleSheetsLogo,
          },
        })}
        options={[
          {
            label: "Select an object",
            value: "default",
          },
        ]}
        value="default"
        onChange={noop}
      />
    </Box>
  </Box>
);

export const DbtImage: FC = () => (
  <Box
    aria-hidden
    bg="white"
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    className="preview-image"
    display="grid"
    gridTemplateColumns="1fr"
    gridTemplateRows="repeat(3, 1fr)"
    height="100px"
    overflow="hidden"
    pointerEvents="none"
    sx={{
      "*": {
        fontSize: "sm",
      },
    }}
  >
    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={3} src={dbtLogo} alt="dbt logo" />
      <Text fontWeight="medium">dbt.model.name.1</Text>
    </Box>

    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={3} src={dbtLogo} alt="dbt logo" />
      <Text fontWeight="medium">dbt.model.name.2</Text>
    </Box>

    <Box alignItems="center" display="flex" gap={2} px={2.5}>
      <HTImage boxSize={3} src={dbtLogo} alt="dbt logo" />
      <Text fontWeight="medium">dbt.model.name.3</Text>
    </Box>
  </Box>
);

export const LookerImage: FC = () => (
  <Box
    aria-hidden
    bg="white"
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    className="preview-image"
    display="grid"
    gridTemplateColumns="1fr"
    gridTemplateRows="repeat(3, 1fr)"
    height="100px"
    overflow="hidden"
    pointerEvents="none"
    sx={{
      "*": {
        fontSize: "sm",
      },
    }}
  >
    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={3} src={lookerLogo} alt="looker" />
      <Text fontWeight="medium">Look 1</Text>
    </Box>

    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={3} src={lookerLogo} alt="looker" />
      <Text fontWeight="medium">Look 2</Text>
    </Box>

    <Box alignItems="center" display="flex" gap={2} px={2.5}>
      <HTImage boxSize={3} src={lookerLogo} alt="looker" />
      <Text fontWeight="medium">Look 3</Text>
    </Box>
  </Box>
);

export const SigmaImage: FC = () => (
  <Box
    aria-hidden
    bg="white"
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    className="preview-image"
    display="grid"
    gridTemplateColumns="1fr"
    gridTemplateRows="repeat(3, 1fr)"
    height="100px"
    overflow="hidden"
    pointerEvents="none"
    sx={{
      "*": {
        fontSize: "sm",
      },
    }}
  >
    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={4} src={sigmaLogo} alt="sigma" />
      <Text fontWeight="medium">Workbook 1</Text>
    </Box>

    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={4} src={sigmaLogo} alt="sigma" />
      <Text fontWeight="medium">Workbook 2</Text>
    </Box>

    <Box alignItems="center" display="flex" gap={2} px={2.5}>
      <HTImage boxSize={4} src={sigmaLogo} alt="sigma" />
      <Text fontWeight="medium">Workbook 3</Text>
    </Box>
  </Box>
);

export const SQLImage: FC = () => (
  <Box
    aria-hidden
    bg="white"
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    className="preview-image"
    height="100px"
    overflow="hidden"
    pointerEvents="none"
    position="relative"
  >
    <Box bg="green.100" height="100%" width="34px" />

    <Box
      alignItems="center"
      display="flex"
      fontFamily="mono"
      fontSize="11px"
      gap={2}
      left={0}
      position="absolute"
      right={0}
      top={4}
    >
      <Box
        bg="primary.base"
        color="white"
        pr={2}
        py={0.5}
        textAlign="right"
        width="34px"
      >
        <Box as="span">1</Box>
      </Box>

      <Box as="span">select * from users;</Box>
      <Box bg="primary.base" h={4} w={0.5} />
    </Box>
  </Box>
);

export const TableImage: FC = () => (
  <Box
    aria-hidden
    bg="white"
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    className="preview-image"
    display="grid"
    gridTemplateColumns="1fr"
    gridTemplateRows="repeat(3, 1fr)"
    height="100px"
    overflow="hidden"
    pointerEvents="none"
    sx={{
      "*": {
        fontSize: "sm",
      },
    }}
  >
    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={4} src={schemaIcon} decorative />
      <Text fontWeight="medium">schema.table.name.1</Text>
    </Box>

    <Box
      alignItems="center"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.border"
      display="flex"
      gap={2}
      px={2.5}
    >
      <HTImage boxSize={4} src={schemaIcon} decorative />
      <Text fontWeight="medium">schema.table.name.2</Text>
    </Box>

    <Box alignItems="center" display="flex" gap={2} px={2.5}>
      <HTImage boxSize={4} src={schemaIcon} decorative />
      <Text fontWeight="medium">schema.table.name.3</Text>
    </Box>
  </Box>
);
